<template>

    <DropDown class="locale_dropdown">
        <template v-slot:dropdownLabel>
            <div class="flag_container">
                <IconFlag />
                 <span> {{ $t(currentLocaleTradId) }}</span>
            </div>
        </template>
        <template v-slot:dropdownItems>
            <div v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
                <div class="flag_container" @click="changeLocale(lang)">
                    <img class="locale_flag" :src="flagPath(lang)" /> {{ $t(localeTradId(lang)) }}
                </div>
            </div>
        </template>
    </DropDown>
<!--
  <div class="locale_switcher">
    <select v-model="$i18n.locale">
    </select>
  </div> -->
</template>

<script>

export default {
    name: 'LocaleSwitcher',
    props: {},
    data(){
        return {
            langs: ['fr', 'en']
        }
    },
    computed: {
        currentLocaleTradId(){
            return 'layouts.locales.' + this.$i18n.locale
        }
    },
    methods: {
        flagPath(lang){
            return require("@/assets/flags/" + lang + ".png")
        },
        localeTradId(lang){
            return 'layouts.locales.' + lang
        },
        changeLocale(lang){
            this.$i18n.locale = lang
            this.$date.locale(lang)
            localStorage.setItem('locale', lang)
        }

    }
}
</script>

<style lang="scss" >
.locale_dropdown{
    width: 100%;
    .dropdown-trigger{
        width: 100%;
        .button{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #000;
            color: white;
            border: none;
            padding: 0;
        }
        svg{
            width: 24px;
            height: 30px;
            fill: white;
            margin-right: 12px;
        }
    }
    .icon{
        i{
            margin-top:0!important;
        }

    }
}
.flag_container{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .locale_flag{
        width: 24px;
        margin-right: 12px;
    }
}
.locale_dropdown .dropdown-menu{
    bottom: 0;
    top: initial;
    .flag_container{
        cursor: pointer;
        padding: 4px 8px;
        &:hover{
            color: $primary;
            font-weight: 500;
        }
    }

}
</style>